// API documentation at
// https://eu1.anypoint.mulesoft.com/exchange/96c7cb7d-713f-4091-9ac2-cf9c431d6e1c/exp-biesse-website-api-raml/minor/0.0/console/summary/

export enum ApiEndpoints {
  SIGN_IN = "signin",
  SIGN_UP = "signup",
  LOGOUT = "logout",
  USER_INFO = "userinfo",
  SUBSCRIPTIONS = "subscriptions",
  EVENTS = "events",
  JOB_POSITIONS = "jobpositions",
  BUSINESS_RELATIONSHIP = "valueLists/businessRelationship",
  PROVINCES = "valueLists/province",
  COUNTRY = "valueLists/country",
  MATERIALS = "valueLists/material",
  PROCESS_OF_INTEREST = "valueLists/processOfInterest",
  USERS = "users",
  REQUEST_PRODUCT_INFO = "requests/info",
  REQUEST_DEMO = "requests/demo",
  REQUEST_SUPPORT = "requests/support",
  REQUEST_NEWSLETTER = "requests/newsletter",
}

export const CONSENTS_ENDPOINT = "consents";

export interface ApiError {
  code: string;
  level: string;
  message: string;
  additional_info: string;
}

export interface ApiResponse<T extends object> {
  meta: {
    status: string;
    correlation_id: string;
    timestamp: string;
    errors?: ApiError[];
  };
  data: T | null;
}

export interface GenericApiValue {
  id?: string;
  value?: string;
  defaultValue?: string;
}

export interface UserConsentsApi {
  status: string;
  consentId: string;
}

export interface ApiUserData {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  country: GenericApiValue;
  businessRelationship: GenericApiValue;
  province?: GenericApiValue;
  materials: GenericApiValue[];
  city: string;
  zipCode: string;
  phone: string;
  consents: UserConsentsApi[];
}

export interface ConsentsListItemApi {
  consentId: string;
  title: string;
  value: string;
  mandatory: boolean;
  locale: string;
  policies: Array<{
    url: string;
  }>;
}

export enum ApiCallStatus {
  LOADING = "loading",
  SUCCESS = "success",
  FAILED = "failed",
}

export interface RequestInfoPayload {
  materials: { id: string }[];
  lastName: string;
  company: string;
  machineSerialNumber: string;
  firstName: string;
  country: { id: string };
  zipCode: string;
  email: string;
  gRecaptchaResponse: string;
  province: GenericApiValue;
  phone: string;
  consents: UserConsentsApi[];
  city: string;
  message: string;
  processOfInterest: { id: string }[];
  sourceURL: string;
}
